package eu.bontlab.models

import eu.bontlab.util.Constants.LOREM_IPSUM_SHORT
import eu.bontlab.util.Res


enum class Testimonial(
    val icon: String,
    val image: String,
    val fullName: String,
    val profession: String,
    val review: String,
    val path: String
) {
    First(
        icon = Res.Image.app1,
        image = Res.Image.app_image1,
        fullName = "Mapdroid",
        profession = "Trail planner/GPS tracker",
        review = "Mapdroid is a complete tools for planning, tracking and measure your hiking, trekking and mountain biking trails. \n" +
                "In the \"MANUAL\" mode you can freely mark positions on map and link them to build a track, while in \"LIVE\" mode the App itself will build tracks by recording automatically the GPS positions of your path. \n" +
                "You'll be able to measure lenght, speed and altimetric profile. \n" +
                "Mapdroid is a GPS tracker with a collection of useful tools for your outdoor activities.\n" +
                "It includes: \n" +
                "- a classic compass;\n" +
                "- a directional arrow, to easily reach any position you mark on the map;\n" +
                "- the possibility to orient the map on the screen according to your path direction;   \n" +
                "- the possibility to calibrate the compensation of eventual errors in your device's directional sensor data, caused by electromagnetic interference;\n" +
                "- drawing function to customize the map with your tracks, which you could then capture in a screenshot and share it with your contacts; \n" +
                "\n" +
                "Try Mapdroid!\n" +
                "It will be Your faithful buddy along your outdoor activities",
        path = "#portfolio-Mapdroid"
    ),
    Second(
        icon = Res.Image.app2,
        image = Res.Image.app_image2,
        fullName = "DiaryDroid",
        profession = "Diary/Agenda app",
        review = "DiaryDroid is a typical diary App useful to save your daily thoughts/emotions and plan your activities, keeping track of every interesting detail.\n" +
                "You can also use it as a date book, a travel diary, and/or just for keeping track of your shopping/To-Do lists, personal notes etc..\n" +
                "Your personal information that you enter in DiaryDroid App is stored on your device memory ONLY, it will not be sent and saved in any external server!!\n" +
                "The requested Internet connection is just for light advertisement purposes (necessary to support this App development ;-)",
        path = "#portfolio-Diarydroid"
    ),
    Third(
        icon = Res.Image.app3,
        image = Res.Image.app_image3,
        fullName = "SpinPlayer",
        profession = "Create and enjoy your audio/video playlists",
        review = "SpinPlayer is your new app for creating, storing, and listening to playlists of audio files available on your device. A clean and simple interface with classic playback controls, long-press on labels to load a playlist from the archive, and intuitive drag & drop to reorder the playback sequence. You can use it both to enjoy your favorite music and to organize your audio recordings (like university lectures, medical consultations, work meetings, etc.).\n" +
                "Note: The original audio files on your device are not modified or deleted when you delete a SoundDroid playlist.\n" +
                "What are you waiting for? Try SpinPlayer now!",
        path = "#portfolio-Spinplayer"
    ),
    Fourth(
        icon = Res.Image.app4,
        image = Res.Image.app_image4,
        fullName = "Fantasy Maze 3D (** on maintenance **)",
        profession = "Labyrinth ball game with fanciful 3D scenarios.",
        review = "A classic labyrinth ball game with unexpected 3D scenarios. \n" +
                "This first version of Fantasy Maze 3D starts with 8 levels to complete. Others will be added later. \n" +
                "Before reaching and activating the exit hole (light blue), it is necessary to find three hidden keys. \n" +
                "The levels scenarios become more and more fanciful and difficult to complete successfully, making the game very addicting and fun. \n" +
                "Just try and enjoy it!",
        path = "#portfolio-FantasyMaze3d"
    ),
    Fifth(
        icon = Res.Image.avatar5,
        image = Res.Image.app_image5,
        fullName = "Milena Nesovic",
        profession = "HR Recruiter",
        review = LOREM_IPSUM_SHORT,
        path = ""
    ),
    Sixth(
        icon = Res.Image.avatar6,
        image = Res.Image.app_image6,
        fullName = "Aca Rodic",
        profession = "Cyber Security Analyst",
        review = LOREM_IPSUM_SHORT,
        path = ""
    )
}